import Core from './Core';

class User
{
    static Create(googleUser)
    {
        return new Promise((resolve, reject) => {
            let email = googleUser.profileObj.email;
            let id_token = googleUser.getAuthResponse().id_token;
            Core.Instance.Request(Core.Address+"Auth/"+id_token, null, "GET").then((json) => {
                let token = json.token;
                let id = json.id;
                resolve(
                    new User(token, email, id)
                );
            });
        });
    }


    constructor(token, email, id)
    {
        this.token = token;
        this.email = email;
        this.id = id;
        this.since = new Date().getTime()/1000;
    }

    Save()
    {
        localStorage.setItem("User", JSON.stringify(this));
    }

    RegisterEdit(clientId, reason)
    {
        let edit = 
        {
            "Client_id" : clientId,
            "reason" : reason,
            "date" : (new Date()).getTime()/1000,
            "email" : this.email
        };
        return Core.Instance.Request(Core.Address+"Edit", edit, "POST");
    }

    static Load()
    {
        let user = null;
        if(localStorage.getItem("User") !=null && localStorage.getItem("User") != "null")
        {
            let data = JSON.parse(localStorage.getItem("User"));
            if((new Date().getTime()/1000) - data.since >=  7200) // déconnexion automatique au bout de deux heures
            {
                User.Erase();
                return user;
            }
            user = new User(data.token, data.email, data.id);
        }
        return user;
    }

    static Erase()
    {
        localStorage.setItem("User", null);
        return null;
    }
}

export default User;


// WEBPACK FOOTER //
// ./src/Core/User.js